import { store$ } from '@redux/store';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { selectLoading } from 'layout/redux/selectors';
import loadAnalytics from 'libraries/segmentAnalyticsLibrary';
import LoadingStatus from 'enums/loadingStatus';
import { segmentTrack, segmentImpression, segmentIdentify, segmentPageView } from './redux/actions';

require('./redux/beaconMiddleware');

const segmentAnalyticsLoaded = () => {};
const segmentAnalyticsErrored = () => {};

const onConfigurationLoaded$ = store$.pipe(
  map(selectLoading),
  filter((loadingStatus) => loadingStatus === LoadingStatus.Succeeded.toString()),
  distinctUntilChanged()
);

// Loads segment analytics library
/* `loadAnalytics(segmentAnalyticsLoaded, segmentAnalyticsErrored);` is calling the `loadAnalytics`
function from the `segmentAnalyticsLibrary` module and passing two callback functions
`segmentAnalyticsLoaded` and `segmentAnalyticsErrored` as arguments. These callback functions will
be executed depending on whether the analytics library is successfully loaded or if there is an
error during the loading process. */
onConfigurationLoaded$.subscribe(() => loadAnalytics(segmentAnalyticsLoaded, segmentAnalyticsErrored));

export { segmentTrack, segmentImpression, segmentIdentify, segmentPageView };
